import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAAQ0VFmU_ch9Na67_Wv5EDGHdSenRM65o",
    authDomain: "dawkimobility-be161.firebaseapp.com",
    projectId: "dawkimobility-be161",
    storageBucket: "dawkimobility-be161.firebasestorage.app",
    messagingSenderId: "464735584435",
    appId: "1:464735584435:web:e999d4a37e3946e6f4f0c6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app; 